import { BlobWriter, configure as zipConfigure, HttpReader, ZipWriter } from '@zip.js/zip.js';

import { DownloadImageUrl } from 'apis/mips/types';

export const fetchZipBlob = async (downloadData: DownloadImageUrl[]) => {
  zipConfigure({
    useWebWorkers: false,
  });
  const zipWriter = new ZipWriter(new BlobWriter('application/zip'));
  const zipAddPromises = downloadData.map(({ downloadUrl, fileName }) =>
    zipWriter.add(
      fileName,
      new HttpReader(downloadUrl, {
        preventHeadRequest: true,
        headers: new Map().set('Cache-Control', 'no-cache'),
      }),
    ),
  );

  await Promise.all(zipAddPromises);
  return zipWriter.close();
};

export const downloadFile = (blob: Blob, fileName?: string) => {
  // make and click a temporary link to download the Blob
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = fileName ? slugify(fileName) : 'photoShoot.zip';
  link.click();
  link.remove();
  // don't forget to revoke your Blob URLs, or it will be held im browsers memory!
  URL.revokeObjectURL(link.href);
};

/**
 * Slugifies a string by replacing all non-alphanumeric characters with underscores and lowercasing the result.
 */
const slugify = (text: string) => text.replace(/[^a-z0-9]/gi, '_').toLowerCase();
